import { render, staticRenderFns } from "./DialogLinkGroupInfo.vue?vue&type=template&id=40c391e6"
import script from "./DialogLinkGroupInfo.vue?vue&type=script&lang=js"
export * from "./DialogLinkGroupInfo.vue?vue&type=script&lang=js"
import style0 from "./DialogLinkGroupInfo.vue?vue&type=style&index=0&id=40c391e6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports